<template>
  <div>
    <div class="background">
      <div class="name">
        <span class="full-name">YARDEN NEGRI</span>
        <span class="title">FRONTEND & FULL STACK ENGINEER</span>
        <div data-aos="fade-down" data-aos-delay="450">
          <button class="projects-btn" href="#" v-scroll-to="'#projects'">SEE PROJECTS</button>
        </div>
      </div>
    </div>
    <div class="main">
      <About />
      <Technologies />
      <Projects />
      <Footer />
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import About from "./about";
import Technologies from "./technologies";
import Projects from "./projects";
import Footer from "./footer";
AOS.init();

export default {
  data() {
    return {};
  },
  components: {
    About,
    Technologies,
    Projects,
    Footer
  },
  methods: {}
};
</script>

<style>
</style>